/**
 * Les sociétés du compte, rangées : les magasins dont la personne est cliente
 * (ses fournisseurs), et ses propres entreprises.
 *
 * @param {object[]} societes sociétés du compte, la courante signalée
 * @returns {{fournisseurs: object[], entreprises: object[]}} les deux listes
 */
export function fournisseursDe(societes) {
  const liste = Array.isArray(societes) ? societes : [];
  const estClient = (s) => String(s.role || '').toUpperCase() === 'CLIENT';
  return {
    fournisseurs: liste.filter(estClient),
    entreprises: liste.filter((s) => !estClient(s)),
  };
}

/**
 * Les adresses d'une liste collée : une par ligne, ou séparées par des
 * virgules, des points-virgules, des espaces.
 *
 * @param {string} texte liste saisie
 * @returns {string[]} les adresses, sans doublon
 */
export function adressesDe(texte) {
  const vues = [];
  String(texte || '')
    .split(/[\s,;]+/)
    .map((a) => a.trim())
    .filter(Boolean)
    .forEach((a) => {
      if (!vues.some((v) => v.toLowerCase() === a.toLowerCase())) vues.push(a);
    });
  return vues;
}

/**
 * Le chantier en un libellé : son numéro devant, « 2026-014 · Villa Morin ».
 *
 * @param {string} [numero] numéro du chantier chez le client
 * @param {string} [nom] nom du chantier
 * @returns {string} le libellé, vide sans l'un ni l'autre
 */
export function libelleChantier(numero, nom) {
  return [numero, nom]
    .map((s) => String(s || '').trim())
    .filter(Boolean)
    .join(' · ');
}

/** Où la commande en cours se souvient de son chantier et de son fournisseur. */
const CLE_COMMANDE = 'swisstech.portail.commande';

/**
 * La commande en cours : le chantier choisi, le fournisseur, l'étape. Elle
 * survit au changement de magasin, qui recharge la page.
 *
 * @returns {{chantier?: object, fournisseurId?: number, etape?: string, garde?: boolean}} l'état retenu
 */
export function commandeEnCours() {
  try {
    const lu = JSON.parse(window.sessionStorage.getItem(CLE_COMMANDE) || 'null');
    return lu && typeof lu === 'object' ? lu : {};
  } catch {
    return {};
  }
}

/**
 * @param {object} etat la commande en cours à retenir ; vide, elle s'oublie
 */
export function retiensCommande(etat) {
  try {
    if (etat && Object.keys(etat).length) {
      window.sessionStorage.setItem(CLE_COMMANDE, JSON.stringify(etat));
    } else {
      window.sessionStorage.removeItem(CLE_COMMANDE);
    }
  } catch {
    // Stockage refusé (navigation privée) : la commande vit le temps de la page.
  }
}

/** Les initiales d'un nom, pour la pastille. */
export const initiales = (nom) =>
  String(nom || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((m) => m[0].toUpperCase())
    .join('');

/** Les couleurs des pastilles, fond et encre. */
export const PASTILLES = [
  ['#E8F3F5', '#0E6E7E'],
  ['#FFF4E5', '#B45309'],
  ['#EEF0FF', '#4338CA'],
  ['#E8F3EC', '#146C3A'],
];
